import axios from 'axios';

export const checkHost = async (host) => {
  const response = await axios.post('/marketer/site/checkHost', { host });
  return response;
};
